"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Chip = _interopRequireDefault(require("@eig-builder/core-ui/Chip"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  padding: 8px 8px 0px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Adornment Wrapper
var AdornmentWrapper = _styledComponents["default"].div(_templateObject()); // Component


var Adornment = function Adornment(_ref) {
  var selectedItem = _ref.selectedItem,
      prefix = _ref.prefix,
      handleDeleteItem = _ref.handleDeleteItem;
  return _react["default"].createElement(_react["default"].Fragment, null, prefix, selectedItem.map(function (item) {
    var value = item.label || item.value;
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(AdornmentWrapper, {
      key: value,
      className: "autocomplete-adornment-wrapper"
    }, _react["default"].createElement(_Chip["default"], {
      label: value,
      size: "small",
      onDelete: function onDelete() {
        return handleDeleteItem(item);
      }
    })));
  }));
};

Adornment.propTypes = {
  selectedItem: _propTypes["default"].array.isRequired,
  prefix: _propTypes["default"].any,
  handleDeleteItem: _propTypes["default"].func.isRequired
};
var _default = Adornment;
exports["default"] = _default;